export default {"src":"/_next/static/media/innovation.d258591e.svg","height":121,"width":120};